import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useContext } from 'react';
import { ParentContext } from '../cnr/contexts/ParentContext';
import NonAuthPage from '../components/alerts/NonAuthPage';
import SignIn from '../components/auth/SignIn';
import { SignInTemp } from '../components/auth/SignInTemp';
import { gEnums } from '../enums/globalEnums';
import MotionWait from '../motions/MotionWait';

/**
 * 
 * @param {*} props (view, appUser, loggedIn, pageAccess)
 * @returns SignIn, SignInTemp, NonAuthPage
 */
const AppContentAlt = (props) => {

  const { view, appUser, loggedIn, pageAccess, fromDirect } = props
  const { allowPageView } = pageAccess ? pageAccess : {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appUser_state } = states
  const appUserAccess = useAppUserAccess()
  const { loggedIn: loggedIn_au } = appUserAccess ?? {}

  const notAllowedContent = () => {
    if (!loggedIn) {
      return <SignIn origin={'appContentAlt'} fromDirect={fromDirect} />
    } else {
      switch (allowPageView) {
        case gEnums.viewPermissionTypes.allowTemp:
          return <SignInTemp />

        case gEnums.viewPermissionTypes.deny:
        case gEnums.viewPermissionTypes.deny_noClientKey:
        case gEnums.viewPermissionTypes.deny_noEventKey:
        case gEnums.viewPermissionTypes.allow_clientLimited:
          if (loggedIn) {
            switch (view) {
              // case 'home':
              //   return <AltPage type={altPageTypes.welcome} />
              default:
                if (appUser.profileValidated) {
                  return <NonAuthPage itemType={'page'} allowPageView={allowPageView} wrapWithAc={true} />
                } else {
                  return <MotionWait origin={'AppContentAlt'} />
                }
            }
          } else {
            return <SignIn origin={'appContentAlt'} fromDirect={fromDirect} />
          }
        default:
          return <div></div>
        // return <JsonViewer json={appUserAccess} />
        // nothing
      }
    }
  }

  return notAllowedContent()

}

export default AppContentAlt